export interface ISocialLink {
  id: "instagram" | "facebook" | "linkedin" | "youtube";
  label: string;
  href: string;
}

/**
 * Social URLs used across the app (Footer, marketing pages, etc.).
 *
 * If a link is empty, consuming UI should hide that icon/link.
 * Update these values with your real URLs.
 */
export const SOCIAL_LINKS: readonly ISocialLink[] = [
  {
    id: "instagram",
    label: "Instagram",
    href: "https://instagram.com/tippoapp",
  },
  {
    id: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61585282683721",
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/tippo-app/",
  },
  {
    id: "youtube",
    label: "YouTube",
    href: "https://www.youtube.com/@Tippo-ATipOutApp",
  },
  // {
  //   id: "x",
  //   label: "X",
  //   href: "https://x.com/tippoapp",
  // },
] as const;
